import React, { CSSProperties, useContext } from 'react';

import { APIProvider } from '@vis.gl/react-google-maps';
import { ApplicationConfigContext } from '@/components/common/ApplicationConfigProvider/ApplicationConfigProvider';
import GoogleMapInner from './GoogleMapInner';
import styles from './GoogleMap.module.css';

export interface mapProps {
	name?: string;
	latitude: number;
	longitude: number;
}
interface props {
	locations: mapProps[];
}
interface mapCSSVars extends CSSProperties {
	'--map-block-size': string;
}
export default function GoogleMap({ locations }: props) {
	const appConfigContext = useContext(ApplicationConfigContext);

	return (
		<div
			className={styles.mapContainer}
			style={
				{
					'--map-block-size': locations.length === 1 ? '124px' : '248px',
				} as mapCSSVars
			}
		>
			{appConfigContext && appConfigContext?.GOOGLE_MAPS_TOKEN && (
				<APIProvider apiKey={appConfigContext.GOOGLE_MAPS_TOKEN}>
					<GoogleMapInner locations={locations} />
				</APIProvider>
			)}
		</div>
	);
}
